// extracted by mini-css-extract-plugin
export var carouselNav = "videocarousel-module--carousel-nav--643d7";
export var content = "videocarousel-module--content--6e3b1";
export var inner = "videocarousel-module--inner--b881e";
export var nextUp = "videocarousel-module--next-up--f4ad8";
export var thumbnail = "videocarousel-module--thumbnail--17c84";
export var title = "videocarousel-module--title--a1cb7";
export var titleVideo = "videocarousel-module--title-video--1a8dc";
export var wrap = "videocarousel-module--wrap--ba5f0";
export var youtube = "videocarousel-module--youtube--d5854";